import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shadow-type" }

import { computed, ref, watch, PropType } from 'vue';
import i18n from '@/plugins/i18n';
import { useI18n } from 'vue-i18n';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

interface IType {
  name: string;
  value: number;
  icon: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ShadowType',
  props: {
  modelValue: {
    type: Number as PropType<number>,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit;

const props = __props;

const typesList = ref<IType[]>([
  {
    name: t('shadow.front'),
    value: 0,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/front.svg'),
  },
  {
    name: t('shadow.top'),
    value: 1,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/position/top-position.svg'),
  },
  {
    name: t('shadow.isometric'),
    value: 2,
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/shadow/isometric.svg'),
  },
]);

const lang = computed(() => i18n.global.locale.value);

const updateTypeHandler = (newVal: number): void => {
  emits('update:modelValue', newVal);
};

watch(lang, () => {
  typesList.value = [
    {
      name: t('shadow.front'),
      value: 0,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/front.svg'),
    },
    {
      name: t('shadow.top'),
      value: 1,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/position/top-position.svg'),
    },
    {
      name: t('shadow.isometric'),
      value: 2,
      // eslint-disable-next-line global-require
      icon: require('@/assets/icons/shadow/isometric.svg'),
    },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typesList.value, (type) => {
      return (_openBlock(), _createBlock(AiClearButton, {
        key: type.value,
        class: _normalizeClass(["shadow-type__item", { 'shadow-type__item--active': props.modelValue === type.value }]),
        onClick: ($event: any) => (updateTypeHandler(type.value))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_inline_svg, {
            src: type.icon
          }, null, 8, ["src"]),
          _createTextVNode(" " + _toDisplayString(type.name), 1)
        ]),
        _: 2
      }, 1032, ["class", "onClick"]))
    }), 128))
  ]))
}
}

})